import { Route } from "react-router-dom";
import "./App.css";
import Header from "./comp/Header";
import Home from "./comp/Home";
import Commiittee from "./comp/Commiittee";
import CallForPapers from "./comp/CallForPapers";
import KeyNotesSpeaker from "./comp/KeyNotesSpeaker";
import Publication from "./comp/Publications";
import Submission from "./comp/Submission";
import Registration from "./comp/Registration";
import Venue from "./comp/Venue";
import Contact from "./comp/Contact";

function App() {
  return (
    <div>
      <Header />
      <Route exact path="/" component={Home}></Route>
      <Route path="/commiittee" component={Commiittee}></Route>
      <Route path="/callforpapers" component={CallForPapers}></Route>
      <Route path="/keynotespeaker" component={KeyNotesSpeaker}></Route>
      <Route path="/publication" component={Publication}></Route>
      <Route path="/submission" component={Submission}></Route>
      <Route path="/registration" component={Registration}></Route>
      <Route path="/venue" component={Venue}></Route>
      <Route path="/contact" component={Contact}></Route>
    </div>
  );
}

export default App;
